interface ActivityLogType {
  merchant_id: string
  action_name: string
  entity_name: string
  role: string
  store_user_id: string
  timestamp: string
  user_email: string
  user_name: string
}

export const toPascalCase = (str: string): string => {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

const roundToMidnight = (date: Date) => {
  const newDate = new Date(date)
  newDate.setHours(0, 0, 0, 0)
  return newDate.getTime()
}

const roundToEndOfDay = (date: Date) => {
  const newDate = new Date(date)
  newDate.setHours(23, 59, 59, 999)
  return newDate.getTime()
}

const formatTimestamp = (timestamp: string, includeTime = true) => {
  const date = new Date(parseInt(timestamp))
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }

  const formatter = new Intl.DateTimeFormat(navigator.language, options)
  const parts = formatter.formatToParts(date)
  const day = parts.find(part => part.type === 'day')?.value
  const month = parts.find(part => part.type === 'month')?.value
  const year = parts.find(part => part.type === 'year')?.value
  const hour = parts.find(part => part.type === 'hour')?.value.padStart(2, '0')
  const minute = parts.find(part => part.type === 'minute')?.value.padStart(2, '0')
  const ampm = parts.find(part => part.type === 'dayPeriod')?.value
  return includeTime ? `${month} ${day}, ${year} at ${hour}:${minute} ${ampm}` : `${month} ${day}, ${year}`
}

const groupByDate = (logs: ActivityLogType[]) => {
  return logs.reduce((acc, log) => {
    const dateKey = formatTimestamp(log.timestamp, false)
    if (!acc[dateKey]) {
      acc[dateKey] = []
    }
    acc[dateKey].push(log)
    return acc
  }, {} as Record<string, ActivityLogType[]>)
}

export { roundToMidnight, formatTimestamp, groupByDate, roundToEndOfDay }
